import { render, staticRenderFns } from "./sub-scroll-ani.vue?vue&type=template&id=07914540&scoped=true&"
import script from "./sub-scroll-ani.vue?vue&type=script&lang=js&"
export * from "./sub-scroll-ani.vue?vue&type=script&lang=js&"
import style0 from "./sub-scroll-ani.vue?vue&type=style&index=0&id=07914540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07914540",
  null
  
)

export default component.exports